import r from "./highrise1438.mjs";
function o(t) {
  return t == null ? "" : r(t);
}
export {
  o as default
};
